module.exports = __webpack_public_path__ + "static/img/left-back.54a074bb.png";